"use client";
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import * as React from 'react';
import { Icon } from '../../Icon/Icon.web.js';

var _excluded = ["color", "size"];
var IconBlog = function IconBlog(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === undefined ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    sizeProp = _ref$size === undefined ? '48px' : _ref$size,
    props = _objectWithoutProperties(_ref, _excluded);
  var size = sizeProp;
  return /*#__PURE__*/React.createElement(Icon, props, /*#__PURE__*/React.createElement("svg", {
    fill: "none",
    viewBox: "0 0 48 48",
    width: size,
    height: size
  }, /*#__PURE__*/React.createElement("path", {
    fill: color,
    fillRule: "evenodd",
    d: "M33.23 8a4.77 4.77 0 0 1 4.763 4.522l.007.218V17h-2v-.03H7v-2h29v-2.222a2.77 2.77 0 0 0-2.602-2.743L33.23 10H9.77a2.77 2.77 0 0 0-2.764 2.573L7 12.74v22.475a2.77 2.77 0 0 0 2.57 2.778l.2.007h23.46a2.77 2.77 0 0 0 2.765-2.601L36 35.23V34h2v1.23a4.77 4.77 0 0 1-4.557 4.765L33.23 40H9.77a4.77 4.77 0 0 1-4.765-4.538L5 35.21V12.732a4.77 4.77 0 0 1 4.553-4.727L9.77 8zM9 12.47a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0m2 0a.5.5 0 1 0-1 0 .5.5 0 0 0 1 0m3.5-1.5a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3m0 1a.5.5 0 1 1 0 1 .5.5 0 0 1 0-1m2.5.5a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0m2 0a.5.5 0 1 0-1 0 .5.5 0 0 0 1 0m9 8.5v1H11v-1zm-2 4v-1H11v1zm-3 5v1H11v-1zm-2 3v1H11v-1zm20.37-17.084 5.654 5.653-13.673 13.674-6.6.934.946-6.599zm2.824 5.653-2.825-2.825-1.32 1.32 2.825 2.825zm-2.735 2.735-2.826-2.826-9.051 9.044-.474 3.3 3.3-.466z",
    clipRule: "evenodd"
  })));
};

export { IconBlog, IconBlog as default };
